module.exports = __webpack_public_path__ + "static/face-052f4db4bee5a66cc62a9151a63baf9f.png";